import { render, staticRenderFns } from "./addNotes.vue?vue&type=template&id=0b73b76a&scoped=true&"
import script from "./addNotes.vue?vue&type=script&lang=js&"
export * from "./addNotes.vue?vue&type=script&lang=js&"
import style0 from "./addNotes.vue?vue&type=style&index=0&id=0b73b76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73b76a",
  null
  
)

export default component.exports